<template>
  <div class="p-2 h-84 w-44 mx-auto shadow bg-white rounded-3xl">
    <div @click="$router.push(`/dish/${item.id}`)">
      <div>
        <img class="rounded-3xl w-40 h-40 object-contain" v-if="item.image" :src="`/media/image/${this.item.image}?size=md`">
        <img class="rounded-3xl w-40 h-40 object-cover" v-else src="@/assets/no-image.jpg"/>
      </div>

      <div class="mt-2 font-bold text-xm h-12" style="-webkit-line-clamp: 2; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden;">
        {{ item.alt_name == '' || item.alt_name == undefined ? item.name : item.alt_name }}
      </div>

      <div class="text-xs h-8 overflow-hidden font-semibold">
        {{ item.description == '' || item.description == undefined ? "Без описания" : item.description }}
      </div>

      <div class="text-xs mt-2 h-4 overflow-hidden font-medium">
        {{ item.volumes == '' || item.volumes == undefined ? "---" : item.volumes }}
      </div>
    </div>

    <button v-if="quantity == 0" class="bg-primary mt-1 text-xl font-bold h-12 text-white w-full rounded-2xl" @click="add()">
      {{ item.price }} ₽
    </button>
    <div v-else class="grid grid-cols-3 justify-start bg-accent mt-1 text-2xl font-bold h-12 text-white w-full content-center rounded-2xl">
      <button class="text-4xl" @click="reduce()">-</button>
      <span class="mt-1 text-center">{{ quantity }}</span>
      <button class="text-4xl" @click="increase()">+</button>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'item' ],

  computed: {
    quantity() {
			try {
				return this.$store.getters.basket[this.item.id].quantity
			} catch {
				return 0
			}
		}
  },

  methods: {
    add() {
      if (this.quantity > 0) {
        this.$store.dispatch('increaseItemInBasket', this.item.id)
      } else {
        this.$store.dispatch('addItemInBasket', this.item)
      }
			this.changeTgBtn()
		},
		increase() {
			this.$store.dispatch('increaseItemInBasket', this.item.id)
			this.changeTgBtn()
		},
		reduce() {
			this.$store.dispatch('reduceItemFromBasket', this.item.id)
			this.changeTgBtn()
		},
    changeTgBtn() {
			const basketItems = Object.values(this.$store.getters.basket)
			if (basketItems.length > 0) {
        window.WebApp.enableClosingConfirmation()
        this.$store.commit('mb_setText', `Мой заказ ${basketItems.reduce(
					(accumulator, val) => accumulator + (val.quantity * val.item.price), 0
				)} ₽`)
        this.$store.commit('mb_show')

				// window.Telegram.WebApp.isClosingConfirmationEnabled = true
				// window.Telegram.WebApp.MainButton.text = `Мой заказ ${basketItems.reduce(
				// 	(accumulator, val) => accumulator + (val.quantity * val.item.price), 0
				// )} ₽`
				// window.Telegram.WebApp.MainButton.show()
			} else {
        window.WebApp.disableClosingConfirmation()
        this.$store.commit('mb_hide')

				// window.Telegram.WebApp.isClosingConfirmationEnabled = false
				// window.Telegram.WebApp.MainButton.hide()
			}
		}
  }
}
</script>

<style>

</style>
